export enum QueryParamKeys {
	CREATE_ORG = "create_org",
}

export type QueryParamValue = string | null;

export interface QueryParamsService {
	get(key: QueryParamKeys): QueryParamValue;
	getAsBoolean(key: QueryParamKeys): boolean;
	getAsNumber(key: QueryParamKeys): number | null;
	has(key: QueryParamKeys): boolean;
}

export class QueryParamsServiceImpl implements QueryParamsService {
	private queryParams: URLSearchParams;

	constructor(queryParams: URLSearchParams) {
		this.queryParams = queryParams;
	}

	get(key: QueryParamKeys): QueryParamValue {
		return this.queryParams.get(key);
	}

	getAsBoolean(key: QueryParamKeys): boolean {
		const value = this.get(key);
		return value === "true";
	}

	getAsNumber(key: QueryParamKeys): number | null {
		const value = this.get(key);
		if (value === null) return null;
		const parsed = Number(value);
		return isNaN(parsed) ? null : parsed;
	}

	has(key: QueryParamKeys): boolean {
		return this.queryParams.has(key);
	}
}

export const AUTH_QUERY_PARAMS = [QueryParamKeys.CREATE_ORG];

export const createQueryParamsService = (queryParams: URLSearchParams): QueryParamsService => {
	return new QueryParamsServiceImpl(queryParams);
};
